<script setup>
import { useAttrs } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

const attrs = useAttrs();
const globalConfig = useMapGetter('globalConfig/get');
</script>

<template>
  <img
    v-if="globalConfig.logoThumbnail"
    v-bind="attrs"
    :src="globalConfig.logoThumbnail"
  />
  <div
    v-else
    v-bind="attrs"
    class="flex items-center justify-center w-full h-full"
    :class="attrs.class || 'size-4'"
  >
    <span class="text-sm font-bold text-n-brand">AI</span>
  </div>
</template>
